import React, { Component } from 'react'

import Showdown from 'showdown'
import InView from '../../containers/SectionWrapper.jsx'
import Media from './Media'
import Button from './Button'
import { Link } from 'react-router-dom'


class Section extends Component {


    render() {
        const converter = new Showdown.Converter({openLinksInNewWindow: true});

        const { id } = this.props.sys
        const { title, project, text, description, url, urlText, media, teaser, isReversed, urlExternal } = this.props.fields
        const { offset } = this.props


        const layout = [<div className="unit half xs-order-1 xs-mb20" key={0}>

            {media && !teaser &&
                <Media data={media} />
            }

            {teaser &&
                <Media data={teaser} caption="Yest" />
            }

        </div>,


        <div className="unit half xs-order-2" key={2}>

            <hr />

            <h2 className="mb10">{title || project}</h2>

            {text && !description &&
                <div className="rich-text" dangerouslySetInnerHTML={{ __html: converter.makeHtml(text) }} />
            }

            {description &&
                <div className="rich-text" dangerouslySetInnerHTML={{ __html: converter.makeHtml(description) }} />
            }

            {url && !description &&
                <p>
                    <Button to={url} className="poke" external={urlExternal}>{urlText}</Button>
                </p>
            }

            {description && project &&
                <p>
                    <Link to={`/work/${id}`} className="poke">
                        More on {project}
                    </Link> 
                </p>
            }
        </div>
        ]


        return (

            <div className="ptlg pblg xs-ptsm xs-pbsm xs-text-center">

                <InView>

                    <div className="grid xs-grid-flex">

                        {(isReversed || offset) &&
                            layout.reverse()
                        }
                        
                        {!isReversed && !offset &&
                            layout
                        }

                    </div>

                </InView>

            </div>

        );
    }
}


export default Section;